import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

export enum SummaryCardType {
  Compacted = 'compacted',
  Detailed = 'detailed',
  Summarized = 'summarized'
}

export interface SummaryCardOption {
  Icon?: Icon;
  Title?: string;
  GridSpan?: number;
  Description: string;
}

export interface SummaryCardHeader {
  Title: string;
  Description: string;
  Icon?: Icon;
  Action?: SummaryCardAction;
}

export interface SummaryCardAction {
  Label?: string;
  Icon?: string;
}
